import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { computeWordDiff, type WordDiffSegment } from '../utils/compute-word-diff';
import { useDiffView } from '../utils/diff-view-context';
type WordDiffProps = {
  current: string;
  suggested: string;
  className?: string;
};
const SEGMENT_CLASS: Record<WordDiffSegment['type'], string> = {
  added: 'text-success bg-success-inverted/[0.08] rounded-[2px]',
  removed: 'text-error line-through decoration-error/50 bg-error-inverted/[0.08] rounded-[2px]',
  unchanged: ''
};
const WordDiff = t0 => {
  const $ = _c(14);
  const {
    current,
    suggested,
    className
  } = t0;
  const {
    showDiff
  } = useDiffView();
  let t1;
  let t2;
  let t3;
  if ($[0] !== className || $[1] !== current || $[2] !== showDiff || $[3] !== suggested) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const segments = computeWordDiff(current, suggested);
      if (!showDiff) {
        const after = segments.filter(_temp).map(_temp2).join("");
        let t4;
        if ($[7] !== className) {
          t4 = cx("whitespace-pre-wrap break-words", className);
          $[7] = className;
          $[8] = t4;
        } else {
          t4 = $[8];
        }
        t3 = <span className={t4}>{after}</span>;
        break bb0;
      }
      if ($[9] !== className) {
        t1 = cx("whitespace-pre-wrap break-words", className);
        $[9] = className;
        $[10] = t1;
      } else {
        t1 = $[10];
      }
      t2 = segments.map(_temp3);
    }
    $[0] = className;
    $[1] = current;
    $[2] = showDiff;
    $[3] = suggested;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t2) {
    t4 = <span className={t1}>{t2}</span>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default WordDiff;
function _temp(segment) {
  return segment.type !== "removed";
}
function _temp2(segment_0) {
  return segment_0.value;
}
function _temp3(segment_1) {
  return <span key={`${segment_1.type}-${segment_1.value}`} className={SEGMENT_CLASS[segment_1.type]}>{segment_1.value}</span>;
}